module.exports = __webpack_public_path__ + "media/images/parallax/illustration-results-a5a196cd77379c71b4ed448f9da41e6b.svg";